
export function getSelectedVariantId() {
    const params = new URLSearchParams(window.location.search);
    const variantParam = params.get('variant');
    
    if (variantParam) {
        const variantId = parseInt(variantParam, 10);
        if (!isNaN(variantId)) return variantId;
    }
    
    const variantInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (variantInput && variantInput.value) {
        const variantId = parseInt(variantInput.value, 10);
        if (!isNaN(variantId)) return variantId;
    }
    
    return null;
}


export function getProductJson() {
    const el = document.getElementById('ProductJson-product-template');
    if (!el) {
        console.warn('getProductJson: ProductJson-product-template element not found. Ensure the theme renders the product JSON tag in the product section.');
        return null;
    }
    
    try {
        return JSON.parse(el.innerHTML);
    } catch (e) {
        console.error('getProductJson: failed to parse product JSON.', e);
        return null;
    }
}

export function getPreviewCoverImage(productJson) {
    if (!productJson) return null;
    
    // Primary: metafield override
    const metafieldValue = productJson.metafields 
        && productJson.metafields.custom 
        && productJson.metafields.custom.preview_cover_image;
    
    if (metafieldValue) {
        const url = metafieldValue.src 
            || metafieldValue.url 
            || (typeof metafieldValue === 'string' ? metafieldValue : null);
        
        if (url) return url;
    }
    
    
    // Fallback: images[0] — original behavior, guaranteed to be a string
    if (productJson.images && productJson.images.length > 0) {
        const firstImage = productJson.images[0];
        if (typeof firstImage === 'string') {
            return firstImage;
        }
        if (firstImage.src) {
            return firstImage.src;
        }
    }
    
    return null;
}